export var DEFAULT_LANGUAGE = 'en';
export var toAvailableLanguage = function toAvailableLanguage(language, links) {
  var codes = Object.keys(links);
  return codes.find(function (s) {
    return s === language;
  }) || codes.find(function (s) {
    return s.substr(0, 2) === language.substr(0, 2);
  }) || DEFAULT_LANGUAGE;
};